export default __webpack_public_path__ + "static/usage-44d1f7fd014502b0b53bfdc2221ae07c.png";